import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "startInput",
    "endInput",
    "durationHint",
    "submitButton",
    "courseSelect",
    "departmentSelect",
  ];

  connect() {
    this.updateDuration();
  }

  updateDuration() {
    if (!this.hasStartInputTarget || !this.hasEndInputTarget) return;

    const startValue = this.startInputTarget.value;
    const endValue = this.endInputTarget.value;

    if (!startValue || !endValue) {
      this.durationHintTarget.textContent = "Duration: --";
      this.durationHintTarget.classList.remove("text-danger");
      this.toggleSubmit(false);
      return;
    }

    const start = new Date(startValue);
    const end = new Date(endValue);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      this.durationHintTarget.textContent = "Duration: --";
      this.durationHintTarget.classList.add("text-danger");
      this.toggleSubmit(false);
      return;
    }

    const durationMinutes = Math.round((end - start) / 60000);
    const durationHours = durationMinutes / 60;
    this.durationHintTarget.textContent = `Duration: ${durationHours.toFixed(2)} hours`;

    const valid = durationMinutes >= 60 && durationMinutes <= 1440;
    this.durationHintTarget.classList.toggle("text-danger", !valid);
    this.toggleSubmit(valid && this.departmentRequirementMet());
  }

  courseChanged() {
    if (!this.hasCourseSelectTarget || !this.hasDepartmentSelectTarget) return;

    const courseId = this.courseSelectTarget.value;
    this.resetDepartmentSelect("Loading departments...");

    if (!courseId) {
      this.resetDepartmentSelect("Select hospital department");
      this.updateDuration();
      return;
    }

    fetch(`/courses/${courseId}/clinical_departments.json`)
      .then((response) => response.json())
      .then((departments) => {
        this.populateDepartmentSelect(departments);
        this.updateDuration();
      })
      .catch(() => {
        this.resetDepartmentSelect("Unable to load departments");
        this.updateDuration();
      });
  }

  populateDepartmentSelect(departments) {
    const select = this.departmentSelectTarget;
    select.innerHTML = "";

    const placeholder = document.createElement("option");
    placeholder.value = "";
    placeholder.textContent = departments.length
      ? "Select hospital department"
      : "No departments configured";
    select.appendChild(placeholder);

    departments.forEach((department) => {
      const option = document.createElement("option");
      option.value = department.id;
      option.textContent = department.name;
      select.appendChild(option);
    });

    select.disabled = departments.length === 0;
    select.required = departments.length > 0;
  }

  resetDepartmentSelect(label) {
    const select = this.departmentSelectTarget;
    select.innerHTML = "";
    const option = document.createElement("option");
    option.value = "";
    option.textContent = label;
    select.appendChild(option);
    select.disabled = true;
    select.required = false;
  }

  departmentRequirementMet() {
    if (!this.hasDepartmentSelectTarget) return true;
    if (!this.departmentSelectTarget.required) return true;

    return this.departmentSelectTarget.value !== "";
  }

  departmentChanged() {
    this.updateDuration();
  }

  toggleSubmit(enabled) {
    if (!this.hasSubmitButtonTarget) return;
    this.submitButtonTarget.disabled = !enabled;
  }
}
